module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_29.e0dcc5f9.png";